import { render, staticRenderFns } from "./qdxxInfo.vue?vue&type=template&id=47f0cc5a&scoped=true"
import script from "./qdxxInfo.vue?vue&type=script&lang=js"
export * from "./qdxxInfo.vue?vue&type=script&lang=js"
import style0 from "./qdxxInfo.vue?vue&type=style&index=0&id=47f0cc5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0cc5a",
  null
  
)

export default component.exports